import { useSyncExternalStore } from 'react';

// A session can end while the app is open: the cookie expires, or the account
// is removed. The API then answers 401 `unauthenticated` to whatever the page
// asks next. The fetch wrapper reports that here; the app turns it into a
// sign-out (the session query flips to "not authenticated", so the gate
// sends the person to the login page) and the login page explains why.

type Listener = () => void;

const listeners = new Set<Listener>();
let ended = false;

/** Called by the fetch wrapper when a protected request came back 401. */
export function reportSessionEnded(): void {
  ended = true;
  for (const listener of listeners) {
    listener();
  }
}

/** Runs `listener` on every report; returns the unsubscribe. */
export function onSessionEnded(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Forget the ended session once the person has signed in again. */
export function clearSessionEnded(): void {
  ended = false;
  for (const listener of listeners) {
    listener();
  }
}

function sessionEnded(): boolean {
  return ended;
}

/** Whether the app is showing the login page because a session ended. */
export function useSessionEnded(): boolean {
  return useSyncExternalStore(onSessionEnded, sessionEnded);
}
